_ = require 'underscore'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
PluginView = require 'app/scripts/views/plugin/plugin-view'
Util = require 'app/scripts/lib/util'

module.exports = class PluginButtonView extends PluginView
  tagName: ->
    if @options.pluginButton.url? then 'a' else 'span'

  attributes: ->
    { url, target } = @options.pluginButton
    if url && pluginValidators.isValidUrlForIframe(url)
      href: url
      target: target ? url
      rel: 'noreferrer nofollow noopener'

  initialize: ({ @pluginButton }) ->
    @retain(@pluginButton)

  events:
    'click': (e) ->
      Util.stopPropagation(e)
      @trackClick?(@pluginButton)
      if @pluginButton.callback?
        @pluginButton.callback
          el: e.currentTarget
        .done()

  template: ->
    throw Error('no template specified')

  renderOnce: ->
    @$el.html(@template(@pluginButton))
    @
